var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "PrintOrSaveInvoicesStepComponent",
    {
      staticClass: "invoices-progress-visualizer-container",
      attrs: { stepNumber: _vm.stepNumber },
    },
    [
      _c(
        "ul",
        { staticClass: "visualizer-list" },
        _vm._l(_vm.invoices, function (file, index) {
          return _c("LfProgressBarComponent", {
            key: index,
            attrs: { file: file, keyName: "numberInvoice" },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }